export function normalizePaginatedReviews(rawPaginatedReviews) {
    return {
        items: rawPaginatedReviews.items ? rawPaginatedReviews.items.map(c => normalizePaginatedReview(c)) : [],
        search_criteria: rawPaginatedReviews.search_criteria,
        total_count: rawPaginatedReviews.total_count
    }
}

export function normalizePaginatedReview(rawPaginatedReview) {
    return rawPaginatedReview;
}